import { forwardRef, useEffect, useImperativeHandle } from 'react'

import {
  Card, Image, Space, Tag, Typography,
  // message
} from 'antd'
import { HeartOutlined, HeartTwoTone } from '@ant-design/icons'
import useStore from '@/hooks/useStore'
import { IUpdateFcltLike } from '@/service/rightNavCtrl'
import './CardComponent.less'

const { Title, Text } = Typography

const CardComponent = forwardRef((props, ref) => {
  // eslint-disable-next-line n/prefer-global/process
  const isDev = process.env.NODE_ENV === 'development'
  const { tag, name, addr, imgSrc, footerTag, idlFcltUnqNo, isFromUrlId, sggCd, like, posFclt } = props
  const facilityStore = useStore('facilityStore')
  const mapStore = useStore('mapStore')

  useImperativeHandle(ref, () => ({
    itemClick,
  }))
  // const [currentFcltId, setCurrentFcltId] = null

  useEffect(() => {
    // const { isFromUrlId } = props
    // if (isFromUrlId) {
    //   const find = facilityStore.SearchResults.find(item => item.idlFcltUnqNo === isFromUrlId)
    //   if (find) {
    //     itemClick(isFromUrlId)
    //   }
    // }
  }, [isFromUrlId])

  const favorites = () => {
    const id = localStorage.getItem('JSESSIONID') || ''
    const obj = {
      idlFcltUnqNo,
      sessionId: isDev ? `${window.SystemConfig.facilitySessionId}` : id,
      apiKey: window.SystemConfig.facilityApiKey,
    }
    IUpdateFcltLike(obj).then((res) => {
      if (res.code === 200) {
        if (facilityStore.searchParams) {
          facilityStore.searchFacility(facilityStore.searchParams)
        }
      }
    })
      .catch((err) => {
        console.log('err', err)
      })
  }

  const favoritesIcon = () => {
    if (like) {
      return <HeartTwoTone twoToneColor="#eb2e95" />
    }
    else {
      return <HeartOutlined style={{ color: '#9a9c9e' }} />
    }
  }

  const tagColor = (str) => {
    let color = ''
    switch (str) {
      case '창업':
        color = '#2E60E9'
        break
      case '문화예술':
        color = '#10b558'
        break
      case '워케이션':
        color = '#FF7700'
        break
      case '기타':
        color = '#0ac9bc'
        break
      case '유휴시설':
        color = '#212529'
        break
      case '전체' :
        color = '#000000'
        break
    }
    return color
  }

  const itemClick = (isFromUrlId = null) => {
    const { x, y } = props
    const id = localStorage.getItem('JSESSIONID') || ''
    const id2 = isDev ? `${window.SystemConfig.facilitySessionId}` : id
    facilityStore.getFacilityLeaseInfo(isFromUrlId || idlFcltUnqNo, id2)
    // facilityStore에 posFclt(x, y 좌표정보) 업데이트
    facilityStore.setPosFclt({ x: props.posFclt.x, y: props.posFclt.y })

    // 이전에 존재하는 poi icon 초기화
    if (window.cviewer && window.cviewer.entities && window.cviewer.entities.values) {
      window.cviewer.entities.values.forEach((entity) => {
        if (window.cviewer.entities.values) {
          window.cviewer.entities.remove(entity)
        }
      })
    }

    // facilityStore.loadTileset(mapStore.viewer, 'http://106.245.249.226:8061/static/tiles/test2/tileset.json', isFromUrlId || idlFcltUnqNo)
    facilityStore.setIdlFcltUnqNo(isFromUrlId || idlFcltUnqNo)
    facilityStore.setClickedSggCdValue(sggCd)
    facilityStore.justClickToHide()
    // load 3dtiles
    facilityStore.load3dTiles(mapStore.viewer, isFromUrlId || idlFcltUnqNo)
    // load wmts
    facilityStore.load3dWMTS(mapStore.viewer, isFromUrlId || idlFcltUnqNo)
    facilityStore.setClickedLonLat([x, y])

    // if (facilityStore.FacilityTileset === null) {
    // // 3dtiles가 없다면 데이터에서 넘어오는 위경도 값으로 위치 이동
    // // 데이터에서 넘어오는 위경도 위치 지도 위 poi icon 표출
    //   if (posFclt && window.cviewer && window.cviewer.entities) {
    //     const targetHeight = 20

    //     const terrainHeightPromise = Cesium.sampleTerrainMostDetailed(window.cviewer.terrainProvider, [
    //       Cesium.Cartographic.fromDegrees(posFclt.x, posFclt.y),
    //     ])

    //     terrainHeightPromise.then((updatedPositions) => {
    //       const terrainHeight = updatedPositions[0].height
    //       window.cviewer.entities.add({
    //         position: Cesium.Cartesian3.fromDegrees(posFclt.x, posFclt.y, terrainHeight + targetHeight),
    //         billboard: {
    //           image: './Symbol/icon-fclt.png',
    //           scale: 2,
    //           verticalOrigin: Cesium.VerticalOrigin.BOTTOM,
    //         },
    //         heightReference: Cesium.HeightReference.CLAMP_TO_GROUND,
    //       })

    //       window.cviewer.camera.flyTo({
    //         destination: Cesium.Cartesian3.fromDegrees(posFclt.x, posFclt.y, 200),
    //         offset: {
    //           heading: Cesium.Math.toRadians(0),
    //           pitch: Cesium.Math.toRadians(-30),
    //           range: 100,
    //         },
    //       })
    //     })
    //   }
    // }
  }

  return (
    <Card size={'small'} hoverable style={{ width: '100%', border: 'none', borderBottom: '1px solid #f2f2f2' }}>
      <div className={'CardContent'} style={{ width: '100%' }}>
        <div className={'LeftDiv'} style={{ float: 'left' }}>
          <div className={'TagPannl'}>
            <div
              className={'TagPart'}
              style={{ float: 'left', height: '24px' }}
            >
              <Space size={[0, 4]} wrap>
                {tag.map((item, index) => (
                  <Tag key={index} color={tagColor(item)}>{item}</Tag>
                ))}
              </Space>
            </div>
            <div
              className={'ButtonPart'}
              style={{ float: 'left', height: '24px' }}
            >
              <a
                onClick={favorites}
                style={{ fontSize: '1.5em', lineHeight: '24px' }}
              >
                {favoritesIcon()}
              </a>
            </div>
          </div>
          <div className={'TextPannl'} style={{ marginRight: 10 }}>
            <Title onClick={() => itemClick()} level={4}>
              {name}
            </Title>
            <Text>{addr}</Text>
          </div>
        </div>
        <div className={'RightDiv'} style={{ float: 'left' }}>
          <Image
            width={100}
            height={100}
            preview={false}
            src={imgSrc}
            onClick={() => itemClick()}
          />
        </div>
      </div>
      <div className={'CardFoot'}>
        <Space size={[0, 0]} wrap style={{ marginTop: 10 }}>
          {footerTag.map((item, index) => (
            <Tag
              key={index}
              style={{ backgroundColor: item === 'LOD4' ? '#FFF176' : '' }}
            >
              {item}
            </Tag>
          ))}
        </Space>
      </div>
    </Card>
  )
})

export default CardComponent
